import { csConstants, siteConstants } from "../../constants";

export function cs(state={}, action) {
  const newState = {...state};
  switch (action.type) {
    case csConstants.INVALID_FILE_SELECTED:
      newState[action.payload.id] = {
        isError: true,
        errorMessage: "Invalid CliftonStrengths 34 report",
      };
      return newState;
    case csConstants.VALIDATE_REQUEST:
      newState[action.payload.id] = {
        isError: false,
        errorMessage: null,
        selectedFilePath: action.payload.report.path,
        selectedFileSize: action.payload.report.size,
        isValidating: true,
      };
      return newState;
    case csConstants.VALIDATE_SUCCESS:
      newState[action.payload.id] = {
        ...newState[action.payload.id],
        reportId: action.payload.data.id,
      };
      return newState;
    case csConstants.VALIDATE_FAILURE:
      newState[action.payload.id] = {
        ...newState[action.payload.id],
        isError: true,
        errorMessage: action.payload.errorMessage,
        isValidating: false,
      };
      return newState;
    case csConstants.VALIDATION_STATUS_SUCCESS:
      switch (action.payload.data.status) {
        case "valid":
          newState[action.payload.id] = {
            ...newState[action.payload.id],
            isError: false,
            errorMessage: null,
            isValidating: false,
            isValid: true,
            clientName: action.payload.data.client_name,
            pageCount: action.payload.data.page_count,
          };
          return newState;
        case "invalid":
          newState[action.payload.id] = {
            ...newState[action.payload.id],
            isError: true,
            errorMessage: siteConstants.ERROR_MSG_INVALID_REPORT,
            isValidating: false,
            isValid: false,
          };
          return newState;
        default:  // "validating"
          return newState;
      }
    case csConstants.VALIDATION_STATUS_FAILURE:
      newState[action.payload.id] = {
        ...newState[action.payload.id],
        isError: true,
        errorMessage: action.payload.errorMessage,
        isValidating: false,
        isValid: false,
      };
      return newState;
    case csConstants.CREATE_ORDER_REQUEST:
      newState.isError = false;
      newState.errorMessage = null;
      newState.isCreatingOrder = true;
      newState.orderId = null;
      return newState;
    case csConstants.CREATE_ORDER_SUCCESS:
      newState.orderId = action.payload.data.id;
      newState.isCreatingOrder = false;
      return newState;
    case csConstants.CREATE_ORDER_FAILURE:
      newState.isError = true;
      newState.errorMessage = action.payload.errorMessage;
      newState.isCreatingOrder = false;
      return newState;
    case csConstants.SET_EMAIL_REQUEST:
      newState.isError = false;
      newState.errorMessage = null;
      newState.clientEmail = action.payload.email;
      newState.isSettingEmail = true;
      newState.selectedBundle = null;
      return newState;
    case csConstants.SET_EMAIL_SUCCESS:
      newState.isSettingEmail = false;
      newState.isEmailSet = true;
      return newState;
    case csConstants.SET_EMAIL_FAILURE:
      newState.isError = true;
      newState.errorMessage = action.payload.errorMessage;
      newState.isSettingEmail = false;
      return newState;
    case csConstants.UNSET_EMAIL:
      newState.isError = false;
      newState.errorMessage = null;
      newState.isEmailSet = false;
      return newState;
    case csConstants.GET_BUNDLES_REQUEST:
      newState.isError = false;
      newState.errorMessage = null;
      newState.isGettingBundles = true;
      return newState;
    case csConstants.GET_BUNDLES_SUCCESS:
      newState.bundles = action.payload.data.bundles;
      newState.isGettingBundles = false;
      return newState;
    case csConstants.GET_BUNDLES_FAILURE:
      newState.isError = true;
      newState.errorMessage = action.payload.errorMessage;
      newState.isGettingBundles = false;
      return newState;
    case csConstants.SET_BUNDLE_REQUEST:
      newState.isError = false;
      newState.errorMessage = null;
      newState.isSettingBundle = true;
      newState.selectedBundle = null;
      return newState;
    case csConstants.SET_BUNDLE_SUCCESS:
      newState.selectedBundle = action.payload.bundleIndex;
      newState.isSettingBundle = false;
      return newState;
    case csConstants.SET_BUNDLE_FAILURE:
      newState.isError = true;
      newState.errorMessage = action.payload.errorMessage;
      newState.isSettingBundle = false;
      return newState;
    case csConstants.CHARGE_CARD_REQUEST:
      newState.isError = false;
      newState.errorMessage = null;
      newState.isChargingCard= true;
      return newState;
    case csConstants.CHARGE_CARD_SUCCESS:
      newState.order = action.payload.data.order;
      newState.isChargingCard= false;
      return newState;
    case csConstants.CHARGE_CARD_FAILURE:
      newState.isError = true;
      newState.errorMessage = action.payload.errorMessage;
      newState.isChargingCard= false;
      return newState;
    default:
      return newState;
  }
}

export function cs2(state={}, action) {
  const {
    selectedFilePath,
    selectedFileSize,
    reportId,
    isValid,
    clientName,
    pageCount,
    orderId,
    clientEmail,
    bundles,
    selectedBundle,
    order,
    thinkificDiscountCode,
  } = state;
  switch (action.type) {
    case csConstants.INVALID_FILE_SELECTED:
      return {
        isError: true,
        errorMessage: "Invalid CliftonStrengths 34 report",
        csDropzoneId: action.payload.id,
      };
    case csConstants.VALIDATE_REQUEST:
      return {
        selectedFilePath: action.payload.report.path,
        selectedFileSize: action.payload.report.size,
        isValidating: true,
        csDropzoneId: action.payload.id,
      };
    case csConstants.VALIDATE_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        isValidating: true,
        reportId: action.payload.data.id,
        csDropzoneId: action.payload.id,
      };
    case csConstants.VALIDATE_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        isError: true,
        errorMessage: action.payload.errorMessage,
        csDropzoneId: action.payload.id,
      };
    case csConstants.VALIDATION_STATUS_SUCCESS:
      switch (action.payload.data.status) {
        case "valid":
          return {
            selectedFilePath,
            selectedFileSize,
            reportId,
            clientName: action.payload.data.client_name,
            pageCount: action.payload.data.page_count,
            isValid: true,
            csDropzoneId: action.payload.id,
          };
        case "invalid":
          return {
            selectedFilePath,
            selectedFileSize,
            reportId,
            isError: true,
            errorMessage: siteConstants.ERROR_MSG_INVALID_REPORT,
            csDropzoneId: action.payload.id,
          };
        default:  // "validating"
          return state;
      }
    case csConstants.VALIDATION_STATUS_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        isError: true,
        errorMessage: action.payload.errorMessage,
        csDropzoneId: action.payload.id,
      };
    case csConstants.CREATE_ORDER_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        isValid,
        clientName,
        pageCount,
        isCreatingOrder: true,
      };
    case csConstants.CREATE_ORDER_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        isValid,
        clientName,
        pageCount,
        orderId: action.payload.data.id,
      };
    case csConstants.CREATE_ORDER_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        isValid,
        clientName,
        pageCount,
        isError: true,
        errorMessage: action.payload.errorMessage,
      };
    case csConstants.SET_EMAIL_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail: action.payload.email,
        isSettingEmail: true,
      }
    case csConstants.SET_EMAIL_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        isEmailSet: true,
      }
    case csConstants.SET_EMAIL_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        isError: true,
        errorMessage: action.payload.errorMessage,
      }
    case csConstants.UNSET_EMAIL:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
      }
    case csConstants.GET_BUNDLES_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        isGettingBundles: true,
      }
    case csConstants.GET_BUNDLES_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles: action.payload.data.bundles,
      }
    case csConstants.GET_BUNDLES_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        isError: true,
        errorMessage: action.payload.errorMessage,
      }
    case csConstants.SET_BUNDLE_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        isSettingBundle: true,
      }
    case csConstants.SET_BUNDLE_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle: action.payload.bundleIndex,
      }
    case csConstants.SET_BUNDLE_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        isError: true,
        errorMessage: action.payload.errorMessage,
      }
    case csConstants.CHARGE_CARD_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        isChargingCard: true,
      }
    case csConstants.CHARGE_CARD_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        order: action.payload.data.order,
      }
    case csConstants.CHARGE_CARD_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        isError: true,
        errorMessage: action.payload.errorMessage,
      }
    case csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_REQUEST:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        order,
        isClaimingThinkificDiscountCode: true,
      }
    case csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_SUCCESS:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        order,
        thinkificDiscountCode: action.payload.data.code,
      }
    case csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_FAILURE:
      return {
        selectedFilePath,
        selectedFileSize,
        reportId,
        clientName,
        pageCount,
        orderId,
        clientEmail,
        bundles,
        selectedBundle,
        order,
        isError: true,
        errorMessage: action.payload.errorMessage,
      }
    default:
      return state;
  }
}